// redux/slices/currencySlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CurrencyState } from '../type'

// Load initial state from localStorage
const getInitialCurrency = (): CurrencyState => {
    if (typeof window !== 'undefined') {
        const savedCurrencySymbol = localStorage.getItem('currencySymbol') || ''
        const savedCurrencyCode = localStorage.getItem('currencyCode') || ''
        const savedCurrency = localStorage.getItem('currency')

        return {
            currencySymbol: savedCurrencySymbol,
            currencyCode: savedCurrencyCode,
            currency: savedCurrency ? JSON.parse(savedCurrency) : undefined
        }
    }

    return {
        currencySymbol: '',
        currencyCode: '',
        currency: undefined
    }
}

const initialState: CurrencyState = getInitialCurrency()

const currencySlice = createSlice({
    name: 'currency',
    initialState,
    reducers: {
        setCurrencyState(
            state,
            action: PayloadAction<{
                currencySymbol: string
                currencyCode?: string
                currency?: {
                    id: number
                    symbol: string
                    name?: string
                }
            }>
        ) {
            state.currencySymbol = action.payload.currencySymbol
            if (action.payload.currencyCode !== undefined) {
                state.currencyCode = action.payload.currencyCode
            }
            if (action.payload.currency !== undefined) {
                state.currency = action.payload.currency
            }

            if (typeof window !== 'undefined') {
                localStorage.setItem(
                    'currencySymbol',
                    action.payload.currencySymbol
                )

                if (action.payload.currencyCode) {
                    localStorage.setItem(
                        'currencyCode',
                        action.payload.currencyCode
                    )
                }

                if (action.payload.currency) {
                    localStorage.setItem(
                        'currency',
                        JSON.stringify(action.payload.currency)
                    )
                }
            }
        }
    }
})

export const { setCurrencyState } = currencySlice.actions
export default currencySlice.reducer
